import Table from '../Table/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVial } from '@fortawesome/pro-solid-svg-icons'

const columnLayout= [
  {
    field: 'checkbox',
    header: '',
    type: 'checkbox',
    width: '40px',
    fieldStyle: 'justify-center'
    },
    {
    field: 'companyUuid',
    header: 'Id',
    type: 'id',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
    {
    field: 'shipmentId',
    header: 'Shipment',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
      {
    field: 'ingredient.name',
    header: 'Ingredient',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2',
    },
      {
    field: 'customer.name',
    header: 'Customer',
    type: 'text',
    style: 'ph2',
    fieldStyle: 'ph2'
    },
]

const AllSamples = (props) => {
  const data = props?.shipments?.rawData
  const loading = props?.shipments?.loading
  return (
    <div className='w-100 ph3'>
      <div className='w-100 pa2 ph3 flex items-center justify-between bg-evonik-purple' >
        <div className='flex items-center'>
          <FontAwesomeIcon className='relative f5 white' icon={faVial} style={{top:-2}}/>
          <div className='pl2 fw7 f6 white'>Incomplete Shipments </div>
          <div className='h2'></div>
        </div>
        {/* <div className='flex'>
          <div className='pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Attach File to Selected
          </div>
          <div className='ml2 pv2 ph3 bg-evonik-light-purple br2 white f6 fw5'>
            Save
          </div>
        </div> */}
      </div>
      <div className='w-100 flex' style={{background: '#f5f3f5'}}>
        <Table _tableName={'incomplete'} _shipments={data} _loading={loading} _columnLayout={columnLayout} {...props}/>
      </div>
    </div>
  )
}

export default AllSamples